import axios from 'axios';

export default async function updating(token: string) {
  const URL = `${process.env.REACT_APP_API_URL}/api/alreadyUpdated/${token}`;
  const response = await axios.patch(URL);
  return response.data;
}
